import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Docs14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_83)'>
      <path
        d='M1.21551 0.781628L6 2.21698L10.7845 0.781628C11.2579 0.639609 11.75 1.00576 11.75 1.5V3.5C11.75 3.91421 11.4142 4.25 11 4.25C10.5858 4.25 10.25 3.91421 10.25 3.5V2.50802L6.21551 3.71837C6.07493 3.76054 5.92507 3.76054 5.78449 3.71837L1.75 2.50802V10.442L6.21551 11.7816C6.61226 11.9007 6.83739 12.3188 6.71837 12.7155C6.59935 13.1123 6.18123 13.3374 5.78449 13.2184L0.784489 11.7184C0.467251 11.6232 0.25 11.3312 0.25 11V1.5C0.25 1.00576 0.742113 0.639609 1.21551 0.781628Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.25 8.49999C5.25 6.42892 6.92893 4.74999 9 4.74999C11.0711 4.74999 12.75 6.42892 12.75 8.49999C12.75 9.26429 12.5214 9.97518 12.1287 10.568L13.5304 11.9697L12.4697 13.0303L11.0681 11.6287C10.4752 12.0213 9.76433 12.25 9 12.25C6.92893 12.25 5.25 10.5711 5.25 8.49999ZM9 6.24999C7.75736 6.24999 6.75 7.25735 6.75 8.49999C6.75 9.74263 7.75736 10.75 9 10.75C10.2426 10.75 11.25 9.74263 11.25 8.49999C11.25 7.25735 10.2426 6.24999 9 6.24999Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_83'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Docs14.displayName = 'Docs14';
export default Docs14;
